import { Eye, FileText } from "lucide-react";

import DetailsCard from "@/components/details/card";

interface ICreditCaseFileBlockProps {
  creditCaseFileUrl: string | null;
  creditCaseFileTitle: string | null;
}

export const CreditCaseFileBlock = ({
  creditCaseFileUrl,
  creditCaseFileTitle,
}: ICreditCaseFileBlockProps) => {
  if (!creditCaseFileUrl) return null;

  const title = creditCaseFileTitle ?? "Open business case";

  return (
    <div
      id="section-financing"
      className="mb-5 w-full px-3"
      style={{ scrollMarginTop: 80 }}
    >
      <DetailsCard title="Financing - business case">
        <div className="flex flex-col gap-3">
          <p className="text-base-secondary">
            See more information about the financing need and qualitative
            information in the business case:
          </p>
          <a
            href={creditCaseFileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-sm bg-primary-150 px-4 py-3 transition-colors hover:bg-primary-100"
          >
            <FileText className="size-5 shrink-0 text-primary" />
            <span className="flex-1 truncate font-semibold text-primary">
              {title}
            </span>
            <Eye className="size-4 shrink-0 text-primary" />
          </a>
        </div>
      </DetailsCard>
    </div>
  );
};
